var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 16 16","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4.229 5.333l-.943.943L8 10.99l4.714-4.714-.943-.943-3.77 3.772-3.772-3.772z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }